import { Component, input } from '@angular/core';
import { LocationState } from '../../store/locations.store';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgIcon } from '@ng-icons/core';

@Component({
  selector: 'app-location-description',
  imports: [TranslocoPipe, NgIcon],
  templateUrl: './location-description.html',
})
export class LocationDescription {
  location = input.required<LocationState>();
}
